import { Grid, Typography } from '@material-ui/core';
import { Button } from 'components/Base';
import React from 'react';

type SignInProps = {};

const SignIn: React.FC<SignInProps> = () => {
  return (
    <Grid container justify="center" alignItems="center" direction="column">
      <Grid item>
        <Typography variant="h5">Welcome again please sign in</Typography>
      </Grid>
      <Grid item>
        <Button
          style={{
            height: 'auto',
            padding: '1rem 2rem',
            marginTop: '1rem'
          }}
        >
          Sign in
        </Button>
      </Grid>
    </Grid>
  );
};

export default SignIn;
